import React from 'react';
import { Provider } from 'mobx-react';
import { Router } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import { QueryClientProvider } from 'react-query';
import bugsnag from '~/src/utils/bugsnag';

import store from '~/src/stores';

import {
  LayoutProvider,
  AnalyticsProvider,
  RouterAnalytics,
  InterceptorProvider,
  ToastProvider,
} from '~/src/contexts';

import App from '~/src/components/App';
import AuthContainer from '~/src/containers/Auth';
import Routes from '~/src/components/Routes';
import WebViewerContextProvider from '~/src/components/Webviewer/WebViewerContextProvider';
import { MuiBase } from '../theme/MuiBase';
import { history } from '../utils/history';
import { queryClient } from '../utils/queryClient';
import { UIFlagsProvider } from '../entities/uiFlags';
import DelightedNpsIntegration from '../components/DelightedNpsIntegration/DelightedNpsIntegration';
import { MavenChat } from '../components/MavenChat/MavenChat';
import ErrorFallback from '../components/ErrorFallback';

const AppContainer = () => {
  const BugsnagErrorBoundary =
    bugsnag.ErrorBoundary as React.ComponentType<any>;
  return (
    <MuiBase>
      <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <Provider store={store}>
              <InterceptorProvider>
                <DndProvider backend={Backend}>
                  <Router history={history}>
                    <AuthContainer>
                      <UIFlagsProvider>
                        <DelightedNpsIntegration />
                        <AnalyticsProvider>
                          <MavenChat />
                          <RouterAnalytics>
                            <LayoutProvider>
                              <App>
                                <WebViewerContextProvider>
                                  <Routes />
                                </WebViewerContextProvider>
                              </App>
                            </LayoutProvider>
                          </RouterAnalytics>
                        </AnalyticsProvider>
                      </UIFlagsProvider>
                    </AuthContainer>
                  </Router>
                </DndProvider>
              </InterceptorProvider>
            </Provider>
          </ToastProvider>
        </QueryClientProvider>
      </BugsnagErrorBoundary>
    </MuiBase>
  );
};

export default AppContainer;
